import { createClient } from '@sanity/client'

const client = createClient({
  projectId: 'anmj3q43', // public, safe
  dataset: 'production',
  apiVersion: '2023-01-01',
  useCdn: true
})

export default client;